<template>
  <div class="login">
    <el-form ref="loginRef" :model="loginForm" :rules="loginRules" class="login-form">
      <h3 class="title">用工管理监控-{{ getTitle }}</h3>

      <el-form-item prop="username">
        <el-input
          v-model="loginForm.username"
          type="text"
          size="large"
          auto-complete="off"
          placeholder="账号"
        >
          <template #prefix><svg-icon icon="user" /></template>
        </el-input>
      </el-form-item>

      <el-form-item prop="password">
        <el-input
          v-model="loginForm.password"
          type="password"
          size="large"
          auto-complete="off"
          placeholder="密码"
        >
          <template #prefix><svg-icon icon="password" /></template>
        </el-input>
      </el-form-item>

      <el-checkbox v-model="loginForm.rememberMe" style="margin:0px 0px 25px 0px;">记住密码</el-checkbox>

      <el-form-item style="width:100%;">
        <el-button
          size="large"
          type="primary"
          style="width:100%;"
          @click.prevent="handleLogin"
        >
          <span>登 录</span>
        </el-button>
      </el-form-item>
    </el-form>

    <!-- 底部 -->
    <div class="el-login-footer">
      <span>Copyright © 2024-2050 南京乐博青科技信息有限公司 版权所有.</span>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import request from '@/util/request'
import qs from 'qs'
import { ElMessage } from 'element-plus'
import Cookies from 'js-cookie'
import { encrypt, decrypt } from '@/utils/jsencrypt'
import router from '@/router'

const props = defineProps({
  loginType: {
    type: String,
    required: true
  }
})

// 标题映射
const titleMap = {
  JG: '监管平台',
  PQ: '环卫企业平台',
  YR: '服务项目平台',
  RY: '人员平台',
  Bank: '银行端'
}

const getTitle = computed(() => {
  return titleMap[props.loginType] || '默认登录'
})

const loginForm = ref({
  username: '',
  password: '',
  rememberMe: false
})

const loginRules = {
  username: [{ required: true, trigger: 'blur', message: '请输入您的账号' }],
  password: [{ required: true, trigger: 'blur', message: '请输入您的密码' }]
}

const loginRef = ref(null)

// ✅ 登录成功处理
const handleLoginSuccess = (data) => {
  ElMessage.success(data.info)

  // 清除旧登录数据
  const oldLoginType = sessionStorage.getItem('currentLoginType')
  if (oldLoginType && oldLoginType !== props.loginType) {
    sessionStorage.removeItem(`${oldLoginType}_token`)
    sessionStorage.removeItem(`${oldLoginType}_currentUser`)
    sessionStorage.removeItem(`${oldLoginType}_menuList`)
    sessionStorage.removeItem(`${oldLoginType}_refresh_token`)
  }

  // ✅ 保存新 token（access）
  sessionStorage.setItem(`${props.loginType}_token`, data.token.access)
  sessionStorage.setItem(`${props.loginType}_refresh_token`, data.token.refresh)
  sessionStorage.setItem(`${props.loginType}_currentUser`, JSON.stringify(data.user))
  sessionStorage.setItem(`${props.loginType}_menuList`, JSON.stringify(data.menuList))
  sessionStorage.setItem('currentLoginType', props.loginType)

  // 记住密码
  if (loginForm.value.rememberMe) {
    Cookies.set(`${props.loginType}_username`, loginForm.value.username, { expires: 30 })
    Cookies.set(`${props.loginType}_password`, encrypt(loginForm.value.password), { expires: 30 })
    Cookies.set(`${props.loginType}_rememberMe`, loginForm.value.rememberMe, { expires: 30 })
  } else {
    Cookies.remove(`${props.loginType}_username`)
    Cookies.remove(`${props.loginType}_password`)
    Cookies.remove(`${props.loginType}_rememberMe`)
  }

  router.replace('/index')
}

// ✅ 登录方法
const handleLogin = () => {
  loginRef.value.validate(async (valid) => {
    if (valid) {
      const requestData = {
        ...loginForm.value,
        type: props.loginType
      }

      try {
        // 使用 post 请求登录
        const result = await request.post('user/login', requestData)
        const data = result.data

        if (data.code === 200) {
          handleLoginSuccess(data)
        } else {
          ElMessage.error(data.info || '登录失败')
        }
      } catch (error) {
        ElMessage.error('网络错误，请检查后端是否运行')
        console.error(error)
      }
    } else {
      ElMessage.error('请填写完整信息')
    }
  })
}

// ✅ 自动填充用户名密码
function getCookie() {
  const username = Cookies.get(`${props.loginType}_username`)
  const password = Cookies.get(`${props.loginType}_password`)
  const rememberMe = Cookies.get(`${props.loginType}_rememberMe`)

  loginForm.value = {
    username: username || loginForm.value.username,
    password: password ? decrypt(password) : loginForm.value.password,
    rememberMe: rememberMe === 'true'
  }
}

getCookie()
</script>

<style lang="scss" scoped>
a {
  color: white;
}
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-image: url('../assets/images/chuzhou.sunhj.cn.jpeg');
  background-size: cover;
}
.title {
  margin: 0px auto 30px auto;
  text-align: center;
  color: #707070;
  font-size: 18px;
  font-weight: bold;
}
.login-form {
  border-radius: 6px;
  background: #ffffff;
  width: 400px;
  padding: 25px 25px 5px 25px;
  .el-input {
    height: 40px;
    input {
      display: inline-block;
      height: 40px;
    }
  }
}
.login-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}
.el-login-footer {
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}
</style>